<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 物品补发申请
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <div>
           <el-select v-model="listQuery.game_id" filterable  placeholder="游戏名称"  style="margin-right:15px;">
              <el-option
                v-for="item in gameNameOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
            </el-select>
          <el-input v-model="listQuery.account"   placeholder="账号" style="width:150px;margin-right:20px;"></el-input>
          <el-select v-model="listQuery.audit_status" filterable  placeholder="状态"  style="margin-right:15px;">
              <el-option
                v-for="item in statusOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
          </el-select>
          <el-select v-model="listQuery.audit_admin_id" filterable  placeholder="处理人"  style="margin-right:15px;">
              <el-option
                v-for="item in personOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
          </el-select>
          <span>平台：</span>
          <el-select v-model="listQuery.platform" filterable   style="margin-right:15px;">
              <el-option
                v-for="item in platformOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
          </el-select>
          <el-select  filterable v-model="listQuery.is_ding_talk" placeholder="通知状态" :disabled="checkData" style="margin-right:15px;">
              <el-option
                v-for="item in noticeStatusOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
          </el-select>
              <el-date-picker
                v-model="listQuery.created_at"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['24:00:00']"
                  style="margin-top:10px;"
              ></el-date-picker>
              <el-input v-model="listQuery.game_role_id"   placeholder="角色ID" style="width:150px;margin-left:20px;"></el-input>
              <el-input v-model="listQuery.game_role_name"   placeholder="角色名" style="width:150px;margin-left:20px;"></el-input>
          </div>
          <div style="float:right; margin:30px 30px 20px 0;">
             <el-button
                  class="filter-item"
                  style="background-color:#00bfbf;color:white;"
                  @click="setTime"
                  v-if="set_time_button"
          >设置时间</el-button>
             <el-button
                  class="filter-item"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
          >搜索</el-button>
          <el-button
                  class="filter-item"
                  type="warning"
                  @click="resetAll"
          >重置</el-button>
          <el-button
                  class="filter-item"
                  type="success"
                  @click="add"
                  v-if = "store_button"
          >添加</el-button>
            <el-button
                  class="filter-item"
                  type="success"
                  @click="lotPass"
                  v-if = "batch_audit_button"
          >批量通过</el-button>
            <el-button
                  class="filter-item"
                  type="warning"
                  @click="sendNotice"
                  v-if = "notice_button"
          >通知</el-button>
          </div>
        </div>
        <el-table border 
        v-loading="listLoading" 
        :data="tableData"
         style="width: 100%" 
           min-height="200"  max-height="1000" 
         @selection-change="handleSelectionChange"
         >
            <el-table-column type="selection" width="50" class = "el-checkbox__inner" />
            <el-table-column prop="game_name" label="游戏名称" width="100" />
            <el-table-column prop="platform" label="平台" width="100"/>
            <el-table-column prop="account" label="账号" width="100" />
            <el-table-column prop="game_role_name" label="角色名" width="100"  />
            <el-table-column prop="game_role_id" label="角色ID" width="100"  />
            <el-table-column prop="game_server" label="区服" width="100" />
            <el-table-column prop="admin_name" label="申请人"  width="100" align="center" />
            <el-table-column prop="provision_reason" label="补发原因"  width="150" :show-overflow-tooltip="true"/>
            <el-table-column prop="provision_item" label="申请物品"  width="100" :show-overflow-tooltip="true" />
            <el-table-column prop="created_at" label="时间"  width="150" />
            <el-table-column prop="audit_status_text" label="状态"  width="100" />
            <el-table-column prop="remark" label="备注"  width="150"  :show-overflow-tooltip="true"/>
            <el-table-column prop="audit_admin_name" label="处理人"  width="100"  />
            <el-table-column prop="is_ding_talk_text" label="通知状态"  width="100"  />
            <el-table-column label="操作"  min-width="520" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="viewRecord(scope.row)" >查看</el-button>
                <el-button size="mini" type="primary" @click="fixRecord(scope.row)"  v-if ="scope.row.update_button" icon="el-icon-edit" >修改</el-button>
                <el-button size="mini" type="success" @click="pass(scope.row)" v-if ="scope.row.audit_success_button" >通过</el-button>
                <el-button size="mini" type="danger" @click="refuse(scope.row)" v-if ="scope.row.audit_failure_button" >拒绝</el-button>
                <el-button size="mini" type="warning" @click="remarkRecord(scope.row)" >备注</el-button>
                <el-button size="mini" type="danger" @click="del(scope.row)" icon="el-icon-delete" v-if ="destroy_button">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-dialog title="删除" width="40%"  center :visible.sync="deleteShow" class="billHandle">
            <p>确认删除？</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="deleteShow = false">取 消</el-button>
              <el-button type="primary" @click="sureDelete">确认</el-button>
            </div>
        </el-dialog>

        <setTimePopup 
        :timeOptions="timeOptions"  
        :setTimeShow="setTimeShow" 
        @deleteTime="deleteTime" 
        @addTime="addTime" 
        @removeTime="removeTime" 
        @sureTime="sureTime" 
        @closeTimeShow="closeTimeShow">
        </setTimePopup>

        <el-dialog title="通过" width="40%"  center :visible.sync="passShow" class="billHandle">
            <p>此操作仅能点击一次，点击后，申请状态为已批，确认进行此操作？</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="passShow = false">取 消</el-button>
              <el-button type="primary" @click="surePass">确认</el-button>
            </div>
        </el-dialog>

         <el-dialog title="通知" width="40%"  center :visible.sync="lotNoticeShow" class="billHandle">
            <p>确认对审批人进行钉钉通知吗？通知后，审批人将收到通知并对您提交的申请进行查看操作。</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="lotNoticeShow = false ">取 消</el-button>
              <el-button type="primary" @click="sureLotNotice">确认</el-button>
            </div>
        </el-dialog>
         
       <el-dialog title="拒绝原因" width="40%"  center :visible.sync="refuseShow" class="billHandle">
             <el-form  style="margin-left:40px;" >
              <el-form-item label="驳回原因" :label-width="formInputWidth" >
                <el-col :span="16" >
                  <el-input  v-model="refuseReason"   type="textarea" :rows="5"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="refuseShow = false">取 消</el-button>
              <el-button type="primary" @click="sureRefuse">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="备注" width="40%"  center :visible.sync="remarkShow" class="billHandle">
          <el-form  style="margin-left:40px;" >
            <el-form-item label="备注" :label-width="formInputWidth" >
              <el-col :span="16" >
                <el-input type="textarea"   v-model="remarkContent" :rows="6"></el-input>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="remarkShow=false">取 消</el-button>
            <el-button type="primary" @click="sureRemark">确认</el-button>
          </div>
       </el-dialog> 

        <el-dialog :title="popupTitle" width="60%"  center :visible.sync="addShow" class="billHandle" @close='closeDialog' :close-on-click-modal= addControl>
          <el-form  style="margin-left:40px;" >
             <el-form-item label="游戏名称" :label-width="formInputWidth" >
              <el-col :span="8" >
                <el-select  filterable v-model="formData.game_id" placeholder="请选择" :disabled="checkData">
                  <el-option
                    v-for="item in gameNameOptions"
                    :key="item.index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="平台" :label-width="formInputWidth" >
              <el-col :span="8" >
                <el-select  filterable v-model="formData.platform" placeholder="请选择" :disabled="checkData">
                  <el-option
                    v-for="item in platformOptions"
                    :key="item.index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label="账号" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input  v-model="formData.account"   :disabled="checkData"></el-input>
              </el-col>
            </el-form-item> -->
            <el-form-item label="账号" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select
                    v-model="formData.account"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    @change="changeAccount"
                  >
                    <el-option
                      v-for="item in userOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>


            <el-form-item label="角色名" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input  v-model="formData.game_role_name"   :disabled="checkData"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="角色ID" :label-width="formInputWidth">
              <el-col :span="8">
                <el-input  v-model="formData.game_role_id"   :disabled="checkData"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="区服" :label-width="formInputWidth">
              <el-col :span="8">
               <el-input  v-model="formData.game_server"   :disabled="checkData"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="补发原因" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input  v-model="formData.provision_reason"   type="textarea" :rows="6" :disabled="checkData"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="申请物品" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input  v-model="formData.provision_item	"   type="textarea" :rows="6" :disabled="checkData"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="备注" :label-width="formInputWidth">
              <el-col :span="16">
                <el-input  v-model="formData.remark"   type="textarea" :rows="6" :disabled="checkData"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="通知人" :label-width="formInputWidth" >
              <el-col :span="16" >
                <el-select  filterable v-model="formData.notice_admin_id" multiple placeholder="请选择" :disabled="checkData">
                  <el-option
                    v-for="item in personOptions"
                    :key="item.index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label="通知形式" :label-width="formInputWidth">
                  <el-col :span="8">
                    <el-radio v-model="formData.send_ding_talk" label="1">即时通知</el-radio>
                    <el-radio v-model="formData.send_ding_talk" label="3">定时通知</el-radio>
                    <el-radio v-model="formData.send_ding_talk" label="2">不进行通知</el-radio>
                  </el-col>
            </el-form-item> -->
          </el-form>
           <el-table  
              :data="formTableData"
              style="width: 100%" 
              v-if="statusLog"
              >
            <el-table-column prop="audit_status_text" label="状态" />
            <el-table-column prop="audit_admin_name" label="操作人"  />
            <el-table-column prop="rollback_reason" label="驳回原因"   :show-overflow-tooltip="true"/>
            <el-table-column prop="audit_at" label="操作时间"  />
          </el-table>
           <div slot="footer" class="dialog-footer" v-if="checkButton">
            <el-button @click="removeAdd">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确认</el-button>
          </div>
        </el-dialog>

        <el-dialog title="通知" width="40%"  center :visible.sync="noticeShow" class="billHandle">
            <p>确认对审批人进行钉钉通知吗？通知后，审批人将收到通知并对您提交的申请进行查看操作。</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeNotice ">取 消</el-button>
              <el-button type="primary" @click="sureNotice">确认</el-button>
            </div>
        </el-dialog>
        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="applicationList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
    getSelectionApi,
    getTalkPersonApi,
    applicationListApi,
    addApplicationApi,
    viewApplicationApi,
    fixApplicationApi,
    examineApi,
    remarkApi,
    delApplicationApi,
    lotExamineApi,
    lotNoticeApi
} from "@/api/applicationGoods.js";
import clone from 'clone'

import {
  getAdminUserListApi
} from '@/api/problem.js';
import { getTimeApi, setTimeApi} from "@/api/setTime.js"
import Pagination from "@/components/pagination/index";
import setTimePopup from "@/components/common/setTimePopup";
import { getUserRole } from '@/api/login.js';
import '@/assets/css/global.css'
    export default {
        components: { Pagination ,setTimePopup},
        name:"applicationGoods",
      data() {
        return {
            listLoading: false,
            total: 0,
            tableData: [],
            userOptions:[],
            listQuery: {
                page: 1,
                limit: 10,
                gameName:"",
                account:"",
                status:"",
                handler:"",
                platform:"",
                is_ding_talk:"",
                noticePerson:"",
                create_time:[],
                game_role_id:"",
                game_role_name:""
            },
            gameNameOptions:[],
            statusOptions:[],
            platformOptions:[],
            noticeStatusOptions:[],
            multipleSelection:[],
            formData:{
              account:"",
              game_id:"",
              game_role_name:"",
              game_role_id:"",
              game_server_id:"",
              game_server_name:"",
              game_server:'',
              platform:"",
              provision_reason:"",
              provision_item:"",
              remark:"",
              notice_admin_id:"",
              send_ding_talk:"3",

              



            },
            // 添加数据的缓存。
            addData:{},
            addCheck:0,

            formTableData:[],
            remarkContent:"",
            operateCheck:"",
            popupTitle:"",

            // 定时时间：
              timeOptions:[
                {
                  value:"",
                  id:new Date()
              }
              ],
            setTimeShow:false,

            // 通知
            noticePerson:[],
            personOptions:[],
            refuseReason:"",
            filterable:true,
            addShow:false,
            deleteShow:false,
            remarkShow:false,
            checkData:false,
            checkButton:false,
            statusLog:false,
            noticeShow:false,
            passShow:false,
            refuseShow:false,
            lotNoticeShow:false,
            formInputWidth: "200px",
            // 权限按钮
            update_button:"",
            audit_failure_button:"",
            audit_success_button:"",
            store_button:"",
            set_time_button:false,
            destroy_button:"",
            notice_button:"",
            batch_audit_button:"",

            fixID:"",
            examineID:"",
            remarkID:"",
            delID:"",
        };
    },
    mounted() {
      this.getSelection();
      this.getNoticePerson();
      this.applicationList();
      this.remoteMethod()
    },
    computed:{
    addControl(){
      let item = true;
      if(this.popupTitle  == "添加"){
        item = false;
      }
      return item;
    }
  },
    methods: {
      async changeAccount(e) {
        const data = this.userOptions.find(item => item.value === e);
        // const response = await getUserRole({game_id:this.formData.game_id,user_name:label})
        console.log(data,'data');
        if (data){
          this.formData.game_role_name = data.role_name;
          this.formData.game_role_id = data.role_id;
          this.formData.game_server_id = data.server_id;
          this.formData.game_server = data.server_id
          this.formData.game_server_name = data.server_name || data.game_server_name;
        }else{
          this.formData.game_role_name = "";
          this.formData.game_role_id = "";
          this.formData.game_server_id = "";
          this.formData.game_server_name = "";
          this.formData.game_server = ''

        }
      },
      remoteMethod(query) {
      if (query !== '') {
        getAdminUserListApi({ account: query })
          .then((response) => {
            this.userOptions = response.data.data.map((item) => {
              return {
                ...item,
                value: `${query}_${item.app_name}(${item.app_key})/${item.role_name}(${item.role_id})/${item.server_id}/${item.user_id}`,
                label: `${item.app_name}(${item.app_key})/${item.role_name}(${item.role_id})/${item.server_id}/${item.user_id}`,
              };
            });
            if (this.userOptions.length == 0) {
              this.userOptions = [
                {
                  value: query,
                  label: query,
                }
              ];
            }
          })
          .catch((error) => {
            this.userOptions = [];
          });
      } else {
        this.userOptions = [];
      }
    },
      getSelection(){
        getSelectionApi()
         .then(response =>{
            this.statusOptions = [] ;
            for(let item of response.data.data.audit_status){
              let arr = {};
              arr.name = item;
              arr.id = this.statusOptions.length;
              this.statusOptions.push(arr);
            }
            this.noticeStatusOptions = [] ;
            for(let item of response.data.data.notice){
              let arr = {};
              arr.name = item;
              arr.id = this.noticeStatusOptions.length;
              this.noticeStatusOptions.push(arr);
            }
            this.gameNameOptions = response.data.data.game   ;
            this.platformOptions = response.data.data.platform ;
         })
         .catch(error=>{})
      },
      getNoticePerson(){
        getTalkPersonApi()
         .then(response =>{
           this.personOptions = response.data.data;
         })
         .catch(error=>{})
      },
      applicationList(){
         this.listLoading = true;
         applicationListApi(this.listQuery)
          .then(response =>{
             this.store_button = response.data.data.store_button;
             this.set_time_button = response.data.data.set_time_button;
             this.destroy_button = response.data.data.destroy_button;
             this.notice_button = response.data.data.notice_button;
             this.batch_audit_button = response.data.data.batch_audit_button;
             this.tableData = response.data.data.data;
             this.total = response.data.data.total;
             this.listLoading = false;
          })
          .catch(error =>{
            this.listLoading = false;
          })
      },
      sendNotice(){
        if(this.multipleSelection.length == 0){
          this.$message.error("请先选择物品补发申请记录");
          return;
        }
        this.lotNoticeShow = true;
      },
      sureLotNotice(){
        let data = {};
        data.id_array = this.multipleSelection;
        lotNoticeApi(data)
         .then(response=>{
           this.resetSearch();
           this.tipsMessage(response);
         })
         .catch(error=>{})
         this.lotNoticeShow = false;
      },
      lotPass(){
         if(this.multipleSelection.length == 0){
          this.$message.error("请先选择物品补发申请记录");
          return;
        }
        let data = {};
        data.id_array = this.multipleSelection;
        lotExamineApi(data)
        .then(response =>{
            this.resetSearch();
            this.tipsMessage(response);
        })
        .catch(error =>{})
      },
      sureNotice(){
        this.formData.send_ding_talk = 1;
        this.dataOperate();
      },
      removeNotice(){
        this.formData.send_ding_talk = 2;
        this.dataOperate();
      },
      dataOperate(){
        const formData = clone (this.formData)
        switch(this.operateCheck) {
          case 0:
            formData.id = this.fixID;
            // 兼容账号
            if (formData.account.includes('_')){
              formData.account = formData.account.split('_')[0]
            }
            fixApplicationApi(this.formData)
            .then(response =>{
              this.noticeShow = false;
              if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.addShow = false;
                this.applicationList();
             }else{
                this.$message.error(response.data.message);
              }
            })
            .catch(error=>{})
            break;
          case 1:
            // 兼容账号
            if (formData.account.includes('_')){
              formData.account = formData.account.split('_')[0]
            }
            
            addApplicationApi(formData).then(response =>{
              this.noticeShow = false;
               if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.addCheck = 2;
                this.addShow = false;
                this.applicationList();
             }else{
                this.$message.error(response.data.message);
              }
            })
            .catch(error=>{})
            break;
          default:
            break;
        }
      },
      search(){
          this.listQuery.page = 1;
          this.applicationList();
      },
       setTime(){
             this.timeOptions = [];
             let data = {};
             data.config_key = "item.send_notice";
             getTimeApi(data)
              .then(response=>{
                for(let item of response.data.data){
                  let m = {
                    value:"",
                    id:new Date()
                  }
                  m.value = item;
                  this.timeOptions.push(m);
                }
                this.setTimeShow = true;
              })
              .catch(error=>{})
          },
          deleteTime(item){
          for (let i = 0;i < this.timeOptions.length; i++){
              if (this.timeOptions[i].id == item.id){
                  this.timeOptions.splice(i,1);
              }
            }
          },
          addTime(){
            let m = {
              value:"",
              id:new Date()
            }
            this.timeOptions.push(m);
          },
          removeTime(){
            this.setTimeShow = false;
          },
          closeTimeShow(){
            this.setTimeShow = false;
          },
          sureTime(){
            let data = {
              config_values:[],
              config_key:""
            }
            data.config_key = "item.send_notice";
            for(let item of this.timeOptions){
              data.config_values.push(item.value);
            }
            setTimeApi(data) 
            .then(response =>{
               if(response.data.code == 200){
                 this.setTimeShow = false;
                 this.$message.success(response.data.message)
                }
                else{
                  this.$message.error(response.data.message)
                }
            })
            .catch(error=>{})
          },
      add(item){
        this.popupTitle = "添加";
        this.checkData = false;
        this.checkButton = true;
        this.statusLog = false;
        this.operateCheck = 1;
        this.reset();
        this.formData.send_ding_talk = "3";
        if(this.addCheck == 1){
          this.formData = JSON.parse(JSON.stringify(this.addData));
        }
        this.addShow = true;
      },
      closeDialog(){
        if(this.popupTitle  == "添加" && (this.addCheck == 0 || this.addCheck == 1)){
           this.addData = JSON.parse(JSON.stringify(this.formData));
           this.addCheck = 1;
        }
        if(this.popupTitle  == "添加" && this.addCheck == 2){
             this.addCheck = 0;
             this.addData = {};
        }
      },
      sureAdd(){
        if(this.formData.send_ding_talk == 1){
          this.noticeShow = true;
        }
        else{
           this.dataOperate();
        }
      },
      removeAdd(){
         this.addShow = false;
      },
      resetAll(){
        this.resetSearch();
        this.applicationList();
      },
      reset(){
      for(let key in this.formData){
          this.formData[key] = "";
        }
      },
      viewRecord(item){
        this.popupTitle = "查看";
        let id = item.id;
        this.viewApplication(id);
        this.checkData = true;
        this.checkButton = false;
        this.statusLog = true;
        this.addShow = true;
      },
      fixRecord(item){
        this.popupTitle = "修改";
        this.fixID = item.id;
        this.viewApplication(this.fixID);
        this.operateCheck = 0;
        this.checkData = false;
        this.checkButton = true;
        this.statusLog = true;
        this.addShow = true;
      },
       viewApplication(id){
        viewApplicationApi(id)
         .then(response=>{
            let data = response.data.data;
            data.send_ding_talk = String(response.data.data.send_notice_type);
            data.notice_admin_id = data.notice_admin_id.map(item => {
              item  = Number(item)
                  return item;
            });
            this.$delete(data,'send_notice_type');
            this.formData = data;

            this.formTableData = [];
            let item = {
              audit_admin_name:"",
              audit_status_text:"",
              rollback_reason:"",
              audit_at:""
            }
            item.audit_admin_name = response.data.data.audit_admin_name;
            item.audit_status_text = response.data.data.audit_status_text;
            item.rollback_reason = response.data.data.rollback_reason;
            item.audit_at = response.data.data.audit_at;
            this.formTableData.push(item);
         })
         .catch(error=>{})
      },
      pass(item){
        this.examineID =  item.id;
        this.passShow = true;
      },
      surePass(){
        let data = {}
        data.audit_status = 3;
        data.id = this.examineID;
        examineApi(data)
         .then(response =>{
           if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.passShow = false;
                this.applicationList();
            }else{
              this.$message.error(response.data.message);
            }
         })
         .catch(error =>{})
      },
      refuse(item){
        this.examineID =  item.id;
        this.refuseReason = "";
        this.refuseShow = true;
      },
      sureRefuse(){
        let data = {}
        data.audit_status = 2;
        data.rollback_reason = this.refuseReason;
        data.id = this.examineID;
         examineApi(data)
         .then(response =>{
           if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.refuseShow = false;
                this.applicationList();
            }else{
              this.$message.error(response.data.message);
            }
         })
         .catch(error =>{})
      },
      del(item){
        this.delID = item.id;
        this.deleteShow = true;
      },
      sureDelete(){
        delApplicationApi(this.delID)
         .then(response=>{
            this.tipsMessage(response);
         })
         .catch(error=>{})
        this.deleteShow = false;
      },
      remarkRecord(item){
        this.remarkID = item.id;
        this.remarkContent = item.remark;
        this.remarkShow = true;
      },
      sureRemark(){
        let data = {}
        data.id = this.remarkID;
        data.remark = this.remarkContent;
        remarkApi(data)
         .then(response =>{
            this.tipsMessage(response);
         })
         .catch(error=>{})
        this.remarkShow = false;
      },
       handleSelectionChange(val){
         this.multipleSelection = [];
         for(let item of val){
           this.multipleSelection.push(item.id)
         }
       },
       tipsMessage(item){
          if(item.data.code == 200){
              this.$message.success(item.data.message);
              this.applicationList();
          }else{
              this.$message.error(item.data.message);
          }
       },
       resetSearch(){
         for(let key in this.listQuery){
              this.listQuery[key] = "";
            }
        this.listQuery.page = 1;
        this.listQuery.limit = 10;
       },
    }
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
